import { TableColumn } from '../../../types/account';

export const DEFAULT_PAGE_SIZE = 10;

export const SPINNER_CLASSNAMES = {
  circle1: '!border-b-partner',
  circle2: '!border-b-partner/50',
};

export const getTableColumns = (t: any): TableColumn[] => [
  {
    key: 'id',
    name: 'ID',
    sortable: false,
  },
  {
    key: 'model',
    name: t('campaignsStats.table.model') || 'Модель',
    sortable: true,
    sortKey: 'model.of_user_name',
  },
  {
    key: 'clicks',
    name: t('campaignsStats.table.clicks') || 'Клики',
    sortable: true,
    sortKey: 'model.transitions_count',
  },
  {
    key: 'click_percent',
    name: t('campaignsStats.table.clickPercent') || '% кликов',
    sortable: true,
    sortKey: 'model.transitions_count_percent',
  },
  {
    key: 'fans',
    name: t('campaignsStats.table.fans') || 'Фаны',
    sortable: true,
    sortKey: 'subscribed_count',
  },
  {
    key: 'revenue',
    name: t('campaignsStats.table.revenue') || 'Доход',
    sortable: true,
    sortKey: 'transactions_statistic.total',
  },
  {
    key: 'three_messages',
    name: t('campaignsStats.table.messages') || 'Сообщения',
    sortable: true,
    sortKey: 'subs.with_gte_3_chat_messages_count',
  },
  {
    key: 'three_messages_percent',
    name: t('campaignsStats.table.messagesPercent') || 'Сообщения %',
    sortable: true,
    sortKey: 'subs.three_message_percent',
  },
  {
    key: 'one_buy',
    name: t('campaignsStats.table.oneBuy') || 'Покупки',
    sortable: true,
    sortKey: 'transactions_statistic.buys',
  },
  {
    key: 'one_buy_percent',
    name: t('campaignsStats.table.oneBuyPercent') || 'Покупки %',
    sortable: true,
    sortKey: 'transactions_statistic.buys_percent',
  },
  {
    key: 'apru',
    name: t('campaignsStats.table.apru') || 'APRU',
    sortable: true,
    sortKey: 'apru',
  },
  {
    key: 'active_period',
    name: t('campaignsStats.table.activity') || 'Активность',
    sortable: true,
    sortKey: 'active_period',
  },
];
